const setContextDataLead = (leadData, formData, context) => {
  context.setUserLeadId(leadData.leadId);
  context.setUserEmail(formData.email || leadData.email);
  context.setUserName(formData.name || leadData.name);
  context.setUserPhone(formData.phone || leadData.phone);
};

export default setContextDataLead;
export { setContextDataLead };
